// extracted by mini-css-extract-plugin
module.exports = {"tooltipTrigger":"TooltipTrigger_tooltipTrigger__3OMvc"};